import { Stack, TextField, Typography } from '@mui/material'
import ContentDialog from '../../../../../components/Dialogs/ContentDialog'
import { useEffect, useState } from 'react'
import { TCheckoutOrder } from '../../../../../core/types/CheckoutOrder'
import Validations from '../../../../../core/functions/validations'
import OrderController from '../../../../../core/controllers/OrderController'
import SendIcon from '@mui/icons-material/Send'
import SuccessSnackbar from '../../../../../components/Snackbar/SuccessSnackbar'
import ErrorSnackbar from '../../../../../components/Snackbar/ErrorSnackbar'

const CheckoutOrderResendEmailDialog = ({
  open,
  setOpen,
  checkoutOrder,
  execute,
}: {
  open: boolean
  setOpen: (open: boolean) => void
  checkoutOrder?: TCheckoutOrder
  execute?: () => void
}) => {
  const [email, setEmail] = useState(checkoutOrder?.email || '')
  const [errorEmail, setErrorEmail] = useState('')
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState('')

  const handleResendEmailClose = () => {
    setErrorEmail('')
    setOpen(false)
  }

  const resendEmail = async () => {
    if (!Validations.email(email)) {
      setErrorEmail('Por favor, insira um e-mail válido.')
      return false
    }
    setSuccess(false)
    setError('')
    try {
      var response = await OrderController.resendEmail({
        checkoutOrderId: checkoutOrder?.id || '',
        email,
      })
      if (!response.success) {
        setError(response.error)
      } else {
        setSuccess(true)
        handleResendEmailClose()
        execute?.()
      }
    } finally {
      return true
    }
  }

  useEffect(() => {
    if (checkoutOrder && checkoutOrder.id) {
      setEmail(checkoutOrder.email || '')
    }
  }, [checkoutOrder])

  return (
    <>
      <ContentDialog
        open={open}
        onClose={handleResendEmailClose}
        title="Reenviar e-mail de entrega do produto"
        buttons={[
          {
            title: 'Cancelar',
            type: 'negative',
            onClick: handleResendEmailClose,
          },
          {
            title: 'Reenviar',
            type: 'positive',
            onClick: resendEmail,
            startIcon: <SendIcon />,
          },
        ]}
      >
        <Stack spacing={3}>
          <Typography>
            Deseja realmente reenviar o e-mail para o cliente?
          </Typography>

          <TextField
            fullWidth
            size="small"
            label="E-mail"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value)
              if (!Validations.email(email)) {
                setErrorEmail('Por favor, insira um e-mail válido.')
              } else {
                setErrorEmail('')
              }
            }}
            error={!!errorEmail}
            helperText={
              errorEmail ||
              'Digite o e-mail para o qual deseja reenviar a mensagem.'
            }
          />
        </Stack>
      </ContentDialog>

      <SuccessSnackbar open={success} onClose={() => setSuccess(false)}>
        E-mail reenviado com sucesso!
      </SuccessSnackbar>

      <ErrorSnackbar open={!!error} onClose={() => setError('')}>
        {error}
      </ErrorSnackbar>
    </>
  )
}

export default CheckoutOrderResendEmailDialog
